<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div v-show="this.$store.state.theme.routeLoading && !this.$store.state.theme.loadingApp" class="route-progress-bar">
    <div class="route-progress-bar__bar"></div>
  </div>

  <div v-show="this.$store.state.theme.loadingApp" class="position-static w-100" style="height: 100vh;">
      <div class="h-100 d-flex justify-content-center align-items-center flex-column loading-screen">
        <div>
          <DotLottieVue autoplay loop src="https://lottie.host/c759f8a9-940b-446e-87bb-4b4143758084/nDoQeNGTCa.lottie" />
        </div>
        <h3 class="loading-text">loading...</h3>
      </div>
  </div>

  <div v-if="showDemoMsg" class="bg-warning text-center z-2000 cursor-pointer position-fixed w-100" @click="stopDemoBot">
    <span class="text-white me-2 font-weight-bold">{{$t('General.DemoNotify')}}</span>
    <span class="text-white small">({{$t('General.DemoNotifyText')}})</span>
  </div>

  <div v-show="!this.$store.state.theme.loadingApp">
    <div
        v-show="this.$store.state.theme.layout === 'landing'"
        class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>
    <sidenav
        :custom_class="this.$store.state.theme.mcolor"
        v-if="this.$store.state.theme.showSidenav"
    />
    <!--        :class="[-->
    <!--      this.$store.state.theme.isTransparent,-->
    <!--      this.$store.state.theme.isRTL ? 'fixed-end' : 'fixed-start'-->
    <!--    ]"-->
    <main
        class="main-content position-relative max-height-vh-100 h-100 border-radius-lg "
    >
      <!-- nav -->
      <navbar
          :class="[navClasses]"
          :textWhite="
        this.$store.state.theme.isAbsolute ? 'text-white opacity-8' : 'text-white'
      "
          :minNav="this['theme/navbarMinimize']"
          v-if="this.$store.state.theme.showNavbar"
      />
      <mobile-breadcrumbs v-if="this.$store.state.theme.showNavbar" />
      <resource-not-connected-alert v-if="user" />
      <router-view />
      <app-footer v-show="this.$store.state.theme.showFooter" />
      <mobile-bottom-bar v-if="this.$store.state.theme.showSidenav" />
      <mobile-sidebar v-if="this.$store.state.theme.showSidenav" />
      <assistant-drawer v-if="user" />
<!--      <configurator-->
<!--          :toggle="this['theme/toggleConfigurator']"-->
<!--          :class="[-->
<!--        this.$store.state.theme.showConfig ? 'show' : '',-->
<!--        this.$store.state.theme.hideConfigButton ? 'd-none' : ''-->
<!--      ]"-->
<!--      />-->
    </main>
  </div>
</template>
<script>
import Sidenav from "./examples/Sidenav";
// import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import MobileBottomBar from "@/components/MobileBottomBar.vue";
import MobileSidebar from "@/components/MobileSidebar.vue";
import MobileBreadcrumbs from "@/components/MobileBreadcrumbs.vue";
import AssistantDrawer from "@/components/AssistantDrawer.vue";
import ResourceNotConnectedAlert from "@/components/ResourceNotConnectedAlert.vue";
import { mapMutations } from "vuex";
// import { Tooltip } from 'bootstrap'
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'
import { useVersionCheck } from '@/composables/useVersionCheck'
import { useI18n } from 'vue-i18n'
import { migrateLocalDashboards } from '@/helpers/dashboardsMigration'

export default {
  name: "App",
  components: {
    Sidenav,
    // Configurator,
    Navbar,
    AppFooter,
    DotLottieVue,
    MobileBottomBar,
    MobileSidebar,
    MobileBreadcrumbs,
    AssistantDrawer,
    ResourceNotConnectedAlert
  },
  data: function() {
    return {
      showDemoMsg: false
    }
  },
  methods: {
    ...mapMutations(["theme/toggleConfigurator", "theme/navbarMinimize"]),
    _onSystemThemeChange() {
      this.$store.commit('theme/applySystemTheme')
    },
    demobotOn: function () {
      this.showDemoMsg = true
      // ElNotification.closeAll()
      //
      // ElNotification({
      //   // title: 'HTML String',
      //   dangerouslyUseHTMLString: true,
      //   message: '<span class="text-white">' + this.$t('General.DemoNotify') + '</span><p class="text-white small">' + this.$t('General.DemoNotifyText') + '</p>',
      //   duration: 0,
      //   // showClose: false,
      //   // type: 'warning',
      //   customClass: 'bg-gradient-danger border-0 text-white',
      //   icon: null,
      //   position: 'bottom-left',
      //   onClose: this.stopDemoBot,
      //   onClick: this.stopDemoBot
      // })
    },
    demobotOff: function () {
      this.showDemoMsg = false
      // ElNotification.closeAll()
    },
    stopDemoBot: function() {
      this.$store.commit('init/resetDemobot')
      this.$router.push({name: "Home"})
    },
    initDemoBOt: async function() {
      this.$store.commit('init/setDemobot')
    },
    trackingChat: function () {
      if (!this.user) {
        return;
      }

      if (window?.$chatwoot?.hasLoaded) {
        this.applySettingsTrack()
      } else {
        window.addEventListener("chatwoot:ready",  () => {
          this.applySettingsTrack()
        })
      }



      // eslint-disable-next-line no-undef
      // if ($zoho?.salesiq?.visitor) {
      //   this.applySettingsTrack()
      // } else {
      //   // eslint-disable-next-line no-undef
      //   $zoho.salesiq.ready= this.applySettingsTrack
      // }
    },
    applySettingsTrack: function() {
        // eslint-disable-next-line no-undef
        // $zoho.salesiq.reset();
        // eslint-disable-next-line no-undef
        // $zoho.salesiq.visitor.id(this.user.key);
        // eslint-disable-next-line no-undef
        // $zoho.salesiq.visitor.email(this.user.email); // this.user.email

        // let bots = []

        let bots = ''
        const bot_count = Object.keys(this.$store.state.init.user_bots).length
        if (bot_count) { //  && bot_count < 4
          let t = 0;
          for (let i in this.$store.state.init.user_bots) {
            if (t>=5) {
              break;
            }
            // bots.push({
            //   name: this.$store.state.init.user_bots[i].bot_name,
            //   status: this.$store.state.init.user_bots[i].status,
            //   key: this.$store.state.init.user_bots[i].key
            // })
            // bots['b_' + this.$store.state.init.user_bots[i].key] = this.$store.state.init.user_bots[i].bot_name + '(' + this.$store.state.init.user_bots[i].status + ') '
            t++;
            bots += this.$store.state.init.user_bots[i].bot_name + '(' + this.$store.state.init.user_bots[i].status + ') '
          }
        }

        // if (bot_count > 5) {
        //   bots = {bot_count: bot_count }
        // }

        //eslint-disable-next-line no-undef
        // $zoho.salesiq.visitor.info(
        //      { ...this.user, ...bots }
        // )

      window.$chatwoot.setUser(this.user.key, {
        email: this.user.email
      });

      let tariff = 'free';
      if (this.user.tariff === 1 ) {
        tariff = 'trial'
      } else if (this.user.tariff === 2 ) {
        tariff = 'base'
      } else if (this.user.tariff === 3 ) {
        tariff = 'advance'
      } else if (this.user.tariff === 4 ) {
        tariff = 'individual'
      }

      window.$chatwoot.setCustomAttributes({
        tariff: tariff,
        bots: bots,
        bot_count: bot_count
      });

      window.$chatwoot.setLocale(this.$i18n.locale);

    },
    tracking: function () {
      if (!this.user) {
        return;
      }

      let tariff = 'free';
      if (this.user.tariff === 1 ) {
        tariff = 'trial'
      } else if (this.user.tariff === 2 ) {
        tariff = 'base'
      } else if (this.user.tariff === 3 ) {
        tariff = 'advance'
      } else if (this.user.tariff === 4 ) {
        tariff = 'individual'
      }


      this.$posthog.identify( this.user.key, {
        'tariff' : tariff,
        'tid': this.user.tid
      });

      if (!this.user.email) {
        return
      }

      let email = this.user.email ? this.user.email : this.user.key + '@graspil.com'



      let bots = ''
      if (Object.keys(this.$store.state.init.user_bots).length) {
        for (let i in this.$store.state.init.user_bots) {
          bots += this.$store.state.init.user_bots[i].bot_name + '(' + this.$store.state.init.user_bots[i].status + '), '
        }
      }
      document.addEventListener("DOMContentLoaded", () => {
        window.sendinblue.identify(email, {
          'KEY': this.user.key,
          'TARIFF' : tariff,
          'TID': this.user.tid,
          'TARIFF_EXPIRATION_DATE': this.user.expiration_date,
          'BOTS': bots
        });

        window.sib.email_id = email;
      })

    }
  },
  computed: {
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.theme.isNavFixed && !this.$store.state.theme.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.theme.isNavFixed && this.$store.state.theme.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state.theme
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.theme.isAbsolute
      };
    },
    hasDemobot: function () {
      return this.$store.getters['init/getHasDemobot']
    },
    user: function () {
      return this.$store.state.init.user
    }
  },
  watch: {
    hasDemobot: function (val) {
      if (val) {
        this.demobotOn()
      } else {
        this.demobotOff()
      }
    },
    user: function (val) {
      this.tracking()
      this.trackingChat()
      if (val) {
        migrateLocalDashboards()
      }
    },
    '$store.state.theme.darkMode': function (val) {
      document.body.classList.toggle('dark-version', val)
    }
  },
  _systemMediaQuery: null,
  created() {
    if (this.hasDemobot) {
      this.demobotOn()
    } else {
      this.demobotOff()
    }
  },
  setup() {
    const { t } = useI18n()
    useVersionCheck(t)
  },
  mounted() {
    this.tracking()
    this.trackingChat()
    // window._paq.push(['trackPageView']);

    // new Tooltip(document.body, {
    //   selector: "[data-bs-toggle='tooltip']",
    // })
  },
  beforeMount() {
    // Применяем тему сразу при монтировании
    document.body.classList.toggle('dark-version', this.$store.state.theme.darkMode)

    // Убираем инлайн-фон выставленный index.html до загрузки бандла —
    // теперь тема управляется классом dark-version, а не inline style.
    document.body.style.removeProperty('background')
    document.documentElement.style.removeProperty('background')
    document.documentElement.classList.remove('dark-preload')

    // Слушаем изменения системной темы (актуально при mode === 'auto')
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    this._systemMediaQuery = mq
    mq.addEventListener('change', this._onSystemThemeChange)
  },
  beforeUnmount() {
    if (this._systemMediaQuery) {
      this._systemMediaQuery.removeEventListener('change', this._onSystemThemeChange)
    }
  },
};
</script>

<style>
.route-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 3000;
  overflow: hidden;
  pointer-events: none;
}
.route-progress-bar__bar {
  position: absolute;
  top: 0;
  left: -40%;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, #5e72e4, #825ee4);
  border-radius: 0 2px 2px 0;
  animation: route-progress-slide 1.1s ease-in-out infinite;
}
@keyframes route-progress-slide {
  0% { left: -40%; }
  100% { left: 100%; }
}
.loading-screen {
  background: #f8f9fa;
}
.dark-version .loading-screen {
  background: #1a1f2b;
}
.loading-text {
  color: #344767;
  font-weight: 600;
  letter-spacing: 0.05em;
}
.dark-version .loading-text {
  color: #e9ecef;
}

/* AssistantDrawer (.ad-panel) is a fixed panel pinned to the right edge, up to 92vw wide on
   narrow screens — shifting the Chatwoot bubble a fixed distance can still leave it overlapping
   the drawer (and stealing clicks meant for the composer), so just hide it outright while the
   drawer is open, at any viewport size. */
body.assistant-drawer-open .woot--bubble-holder,
body.assistant-drawer-open .woot-widget-bubble {
  display: none !important;
}
</style>